var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement, property } from 'lit/decorators.js';
let BadgeComponent = class BadgeComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.icon = '';
        this.size = '';
    }
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-badge {
          font-weight : 400;
        }
        .ggo-badge ggo-icon {
          margin-right: 0.25rem;
        }

        `,
        ];
    }
    render() {
        return html `
      <span class="slds-badge ggo-badge">
        ${this.icon ? html `<ggo-icon icon="${this.icon}" size="${this.size}"></ggo-icon>` : ''}
        <slot></slot>
      </span>
    `;
    }
};
__decorate([
    property({ type: String })
], BadgeComponent.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], BadgeComponent.prototype, "size", void 0);
BadgeComponent = __decorate([
    customElement('ggo-badge')
], BadgeComponent);
export { BadgeComponent };
